$(document).ready(function () {
    CheckCookiesPrivacy();
});

function SaveCookies() {
    var ads = 'denied';
    var astore = 'denied';
    var addata = 'denied';
    var adpers = 'denied';

    var expires = new Date();
    var days = 20 * 365;
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    var cbrun = false;
    var cbadv = false;
    var gs = '0';

    if ($('#ga').is(":checked")) {
        document.cookie = "cbrun=1;expires=" + expires + "; path=/";
        cbrun = true;
        ads = 'granted';
    }
    else {
        sessionStorage.setItem('nocookies', '1');
        document.cookie = "cbrun=0;expires=" + expires + "; path=/";
    }

    if ($('#gads').is(":checked")) {
        document.cookie = "cbadv=1;expires=" + expires + "; path=/";
        cbadv = true;
        astore = 'granted';
    }
    else {
        sessionStorage.setItem('cbadv', '1');
        document.cookie = "cbadv=0;expires=" + expires + "; path=/";
    }

    if ($('#gs').is(":checked")) {
        gs = '1';
        addata = 'granted';
        adpers = 'granted';
    }

    if ($('#lh').is(":checked")) {
        document.cookie = "lh=1;expires=" + expires + "; path=/";
    }
    else {
        sessionStorage.setItem('lh', '1');
        document.cookie = "lh=0;expires=" + expires + "; path=/";
    }

    if ($('#bing').is(":checked")) {
        document.cookie = "bing=1;expires=" + expires + "; path=/";
    }
    else {
        sessionStorage.setItem('bing', '1');
        document.cookie = "bing=0;expires=" + expires + "; path=/";
    }

    if ($('#criteo').is(":checked")) {
        document.cookie = "criteo=1;expires=" + expires + "; path=/";
    }
    else {
        sessionStorage.setItem('criteo', '1');
        document.cookie = "criteo=0;expires=" + expires + "; path=/";
    }

    if ($('#fb').is(":checked")) {
        document.cookie = "fb=1;expires=" + expires + "; path=/";
    }
    else {
        sessionStorage.setItem('fb', '1');
        document.cookie = "fb=0;expires=" + expires + "; path=/";
    }

    document.cookie = "ppkcookie=1;expires=" + expires + "; path=/";
    //SaveCookiesDB(cbrun, cbadv);
    SetConsent(ads, astore, 'update', gs, addata, adpers, 'banner');

    $('.od-cookiedsc').fadeOut(800);
    //popcookies.Hide();
    $("#cookie-popup").dxPopup("hide");
}

function AcceptAllCookies() {
    waiting.Show();
    var expires = new Date();
    var days = 20 * 365;
    var bing = $('#bing').prop('checked');//bing
    var criteo = $('#criteo').prop("checked"); //criteo
    var gs = $('#gs').prop("checked"); //gs

    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = "cbrun=1;expires=" + expires + "; path=/";
    document.cookie = "cbadv=1;expires=" + expires + "; path=/";
    document.cookie = "lh=1;expires=" + expires + "; path=/";
    if (bing == true) {
        document.cookie = "bing=1;expires=" + expires + "; path=/";
    }
    else if (criteo == true) {
        document.cookie = "criteo=1;expires=" + expires + "; path=/";
    }
    else if (gs == true) {
        document.cookie = "gs=1;expires=" + expires + "; path=/";
    }
    document.cookie = "ppkcookie=1;expires=" + expires + "; path=/";
    document.cookie = "fb=1;expires=" + expires + "; path=/";

    //SaveCookiesDB(true, true);
    SetConsent('granted', 'granted', 'update','1', 'granted', 'granted', 'banner');

    waiting.Hide();
    $('.od-cookiedsc').fadeOut(800);
    //popcookies.Hide();
    $("#cookie-popup").dxPopup("hide");
}

function DismissCookies() {
    var expires = new Date();
    var days = 3600 * 1000 * 24 * 365;
    expires.setTime(expires.getTime() + (days));
    document.cookie = "cbrun=0;expires=" + expires + "; path=/";
    document.cookie = "cbadv=0;expires=" + expires + "; path=/";
    document.cookie = "lh=0;expires=" + expires + "; path=/";
    document.cookie = "bing=0;expires=" + expires + "; path=/";
    document.cookie = "criteo=0;expires=" + expires + "; path=/";
    document.cookie = "fb=0;expires=" + expires + "; path=/";
    document.cookie = "ppkcookie=1;expires=" + expires + "; path=/";

    //SaveCookiesDB(false, false);
    SetConsent('denied', 'denied', 'update', '0', 'denied', 'denied');

    waiting.Hide();
    $('.od-cookiedsc').fadeOut(800);
    //popcookies.Hide();
    $("#cookie-popup").dxPopup("hide");
}

function CloseCookieDsc() {
    document.cookie = "session=1;path=/"
    $('.od-cookiedsc').fadeOut(800);
}

function SaveCookiesDB(lcbrun, lcbadv, llh, ldl, lbing, lcriteo) {
    //var result = $.ajax({
    //    cache: false,
    //    type: "POST",
    //    url: "/Services/service.asmx/LogUserCookies",
    //    data: JSON.stringify({ cbrun: lcbrun, cbadv: lcbadv, lh: llh, dl: ldl, bing: lbing, criteo: lcriteo }),
    //    contentType: "application/json; charset=utf-8",
    //    dataType: "string",
    //    async: false,
    //    success: function (data) {

    //    },
    //    error: function (xhr, ajaxOptions, thrownError) {

    //    }
    //});
}

function CheckCookiesPrivacy() {
    try {
        var session = getCookie('session');
        var noc = sessionStorage.getItem('nocookies');
        var ppk = getCookie('ppkcookie'); 

        if (session != 1) {
            if ((ppk == 0 || noc == 0)) {
                var cookieDisclaimer = document.getElementById('cookie-disclaimer');
                if (cookieDisclaimer) {
                    cookieDisclaimer.style.display = 'block';
                }
                CheckVisibilityCookies();
            }
            else {
                console.log('CheckVisibilityCookies');
                CheckVisibilityCookies();
            }
        }        
    } 
    catch(error) {
        console.log(error);
    }
}

function CheckVisibilityCookies() {
    try {
        var ads = 'denied';
        var astore = 'denied';
        var addata = 'denied';
        var adpers = 'denied';
        //var gs = '0';

        var cb1 = getCookie('cbrun'); //google analytics
        var cb2 = getCookie('cbadv'); //google ads
        var lh = getCookie('lh'); //live help
        var bing = getCookie('bing'); //bing
        var cbbing = $('#bing');
        var criteo = getCookie('criteo'); //criteo
        var cbcriteo = $('#criteo');
        var gs = getCookie('gs'); //google signals
        var cbgs = $('#gs');
        var fb = getCookie('fb'); //facebook
        var cbfb = $('#fb');

        var expires = new Date();
        var days = 20 * 365;
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));

        if (cb1.length === 0) {
            ads = 'granted';
            document.cookie = "cbrun=1;expires=" + expires + "; path=/";
        }
        else if (cb1 === '1') {
            ads = 'granted';
        }

        if (cb2.length === 0) {
            astore = 'granted';
            document.cookie = "cbadv=1;expires=" + expires + "; path=/";
        }
        else if (cb2 === '1') {
            astore = 'granted';
            $('#gads')?.attr('checked', '');
        }
        else {
            $('#gads')?.removeAttr('checked');
        }

        if (lh.length === 0) {
            document.cookie = "lh=1;expires=" + expires + "; path=/";
        }
        else if (lh === '1') {
            $('#lh')?.attr('checked', '');
            $('#crun')?.attr('checked', '');
        }
        else {
            $('#lh')?.removeAttr('checked');
            $('#crun')?.removeAttr('checked');
        }

        if (bing.length === 0) {
            document.cookie = "bing=1;expires=" + expires + "; path=/";
        }
        else if (bing === '1') {
            cbbing?.attr('checked', '');
        }
        else {
            cbbing?.removeAttr('checked');
        }

        if (criteo.length === 0) {
            document.cookie = "criteo=1;expires=" + expires + "; path=/";
        }
        else if (criteo === '1') {
            cbcriteo?.attr('checked', '');
        }
        else {
            cbcriteo?.removeAttr('checked');
        }

        if (fb.length === 0) {
            document.cookie = "fb=1;expires=" + expires + "; path=/";
        }
        else if (fb === '1') {
            cbfb?.attr('checked', '');
        }
        else {
            cbfb?.removeAttr('checked');
        }

        if (gs == '1') {
            addata = 'granted';
            adpers = 'granted';
            cbgs?.attr('checked', '');
        }
        else {
            cbgs?.removeAttr('checked');
        }

        if (gs == '1' && bing == '1' && criteo == '1' && fb == '1' && cb2 == '1') {
            $("#crun2")?.attr('checked', '');
        }
        else {
            $("#crun2")?.removeAttr('checked');
        }

        SetConsent(ads, astore, 'update', gs, addata, adpers);

    } catch (err) {
        console.log(err);
    }
}

function SetConsent(ads, astore, action, gs, addata, adpers, mode) {
    var expires = new Date();
    var days = 20 * 365;
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = "ads=" + ads + ";expires=" + expires + "; path=/";
    document.cookie = "astore=" + astore + ";expires=" + expires + "; path=/";
    document.cookie = "gs=" + gs + ";expires=" + expires + "; path=/";
    document.cookie = "addata=" + addata + ";expires=" + expires + "; path=/";
    document.cookie = "adpers=" + adpers + ";adpers=" + expires + "; path=/";
    if (typeof dataLayer !== "undefined") {
        if (mode == "banner") {            
            ga4.e_pushGenericEvent('updateConsentState', 'consent');
        }
        else {
            dataLayer.push("consent", action, {
                ad_storage: ads,
                analytics_storage: astore,
                ad_user_data: addata,
                ad_personalization: adpers,
                wait_for_update: 500
            });
        }
    }
}

function cbrunon() {

    var visibility = $("#crun").prop("checked");
    $("#lh").prop("checked", visibility);
    $("#googlea").prop("checked", visibility);
}

function cbadvon() {

    var visibility = $("#crun2").prop("checked");
    $("#gs").prop("checked", visibility);
    $("#fb").prop("checked", visibility);
    $("#bing").prop("checked", visibility);
    $("#criteo").prop("checked", visibility);
    $("#gads").prop("checked", visibility);
}


function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}